import remove from 'lodash/remove';
import api from '@/api';

export default {
  namespaced: true,

  state: {
    bims: [],
  },

  actions: {
    async AddBim({ commit }, form) {
      const { bim } = await api.bim.createItem({ ...form });
      commit('ADD_BIM', bim);
      return bim;
    },
    async UpdateBim({ commit }, form) {
      const { bim } = await api.bim.updateItem({ ...form });
      commit('UPDATE_BIM', bim);
      return bim;
    },
    async DeleteBim({ commit }, item) {
      await api.measuringPoint.deleteItem({
        projectId: item.projectId,
        structureId: item.structureId,
        bimId: item.id,
      });
      commit('DELETE_BIM', item);
    },
  },
  mutations: {
    ADD_BIM(state, bim) {
      const { bims } = state;
      state.bims = [...bims, bim];
    },
    UPDATE_BIM(state, bim) {
      const { bims } = state;
      const target = bims.find(item => item.id === bim.id);

      if (target) {
        Object.assign(target, bim);
        state.bims = [...bims];
      }
    },
    DELETE_BIM(state, bim) {
      const { bims } = state;
      remove(bims, item => item.id === bim.id);
      state.bims = [...bims];
    },
  },
};
